// Pure parser utilities — no Vue/Pinia imports.
// Canonical source for PascalCase→camelCase key conversion and typed object
// construction. Imported by useWebsocket.ts, useDepthSocket.ts, useMTM.ts,
// useOptionsCalculator.ts, and messageParser.worker.ts.

export function pascalToCamel(str: string): string {
  if (str.toLowerCase() === "contract_type") {
    return "CONTRACT_TYPE";
  }
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, "");
}

export function createTypedObject<U>(data: Record<string, unknown>): U {
  const typedObject: Partial<U> = {};
  for (const key in data) {
    const camelKey = pascalToCamel(key);
    const value = data[key];
    if (
      typeof value === "string" ||
      typeof value === "number" ||
      typeof value === "boolean"
    ) {
      typedObject[camelKey as keyof U] = value as U[keyof U];
    } else if (typeof value === "object") {
      typedObject[camelKey as keyof U] = createTypedObject(
        value as Record<string, unknown>,
      ) as U[keyof U];
    } else {
      throw new Error(`Invalid data for field ${key} ${camelKey} ${value}`);
    }
  }
  return typedObject as U;
}

export function createTypedArray<U>(data: string | object[]): U[] {
  const parsedData = typeof data === "string" ? JSON.parse(data) : data;
  if (!Array.isArray(parsedData)) {
    return [createTypedObject<U>(parsedData)];
  }
  return parsedData.map((item) => createTypedObject<U>(item));
}
